import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { desktopDto } from '@vectronic/desktop-api';
import { combineLatest, map, Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WildlifeFilterService {
  filter = signal<desktopDto.EventRequest>({ count: 100, page: 0 });
  filter$: Observable<desktopDto.EventRequest> = toObservable(this.filter);

  updateFilter(fn: (old: desktopDto.EventRequest) => desktopDto.EventRequest) {
    this.filter.update((old) => ({ ...fn(old), page: 0 }));
  }

  filterShouldBeReadyWithEmptyDeviceIdFilter$ = new ReplaySubject<boolean>();
  isFilterReady$ = combineLatest([
    this.filter$,
    this.filterShouldBeReadyWithEmptyDeviceIdFilter$,
  ]).pipe(
    map(
      ([filter, filterShouldBeReadyWithEmptyDeviceIdFilter]) =>
        filterShouldBeReadyWithEmptyDeviceIdFilter || filter.deviceIds?.length > 0,
    ),
  );
}
